import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    menuSetting: 'unfold',
  },
  actions: {
    setMenuSetting({ commit }, data) {
      commit('SET_MENU_SETTING', data)
    }
  },
  mutations: {
    SET_MENU_SETTING: (state, data) => {
      state.menuSetting = data
    },
  },
  getters
})

export default store